// 设计系统 - 颜色、间距、字体等统一定义
export const Colors = {
  // 主色调 - 旅行蓝色系
  primary: {
    main: '#4A86F7',
    light: '#7CA8FF',
    dark: '#2563EB',
    lighter: '#E8F1FF',
  },
  
  // 次要色调
  secondary: {
    main: '#10B981',
    light: '#34D399',
    dark: '#059669',
    lighter: '#D1FAE5',
  },
  
  // 功能性颜色
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
  
  // 中性色
  neutral: {
    white: '#FFFFFF',
    gray50: '#F9FAFB',
    gray100: '#F3F4F6',
    gray200: '#E5E7EB',
    gray300: '#D1D5DB',
    gray400: '#9CA3AF',
    gray500: '#6B7280',
    gray600: '#4B5563',
    gray700: '#374151',
    gray800: '#1F2937',
    gray900: '#111827',
    black: '#000000',
  },
  
  // 背景色
  background: {
    primary: '#FFFFFF',
    secondary: '#F9FAFB',
    tertiary: '#F3F4F6',
    light: '#F9FAFB',
  },
  
  // 文本颜色
  text: {
    primary: '#111827',
    secondary: '#6B7280',
    tertiary: '#9CA3AF',
    disabled: '#D1D5DB',
    white: '#FFFFFF',
    placeholder: '#9CA3AF',
  },
  
  // 边框颜色
  border: {
    light: '#F3F4F6',
    medium: '#E5E7EB',
    dark: '#D1D5DB',
  },
  
  // 阴影颜色
  shadow: {
    light: 'rgba(0, 0, 0, 0.05)',
    medium: 'rgba(0, 0, 0, 0.1)',
    dark: 'rgba(0, 0, 0, 0.15)',
  },
};

export const Typography = {
  // 字体大小
  fontSize: {
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
  },
  
  // 字重
  fontWeight: {
    light: '300' as const,
    normal: '400' as const,
    medium: '500' as const,
    semibold: '600' as const,
    bold: '700' as const,
  },
  
  // 行高
  lineHeight: {
    tight: 1.2,
    normal: 1.4,
    relaxed: 1.6,
    loose: 1.8,
  },
};

export const Spacing = {
  // 基础间距单位
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  '2xl': 32,
  '3xl': 40,
  '4xl': 48,
  '5xl': 64,
};

export const BorderRadius = {
  none: 0,
  sm: 4,
  base: 8,
  md: 12,
  lg: 16,
  xl: 20,
  full: 9999,
};

export const Shadows = {
  // iOS 风格阴影
  small: {
    shadowColor: Colors.shadow.medium,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 1,
    shadowRadius: 2,
    elevation: 2,
  },
  
  medium: {
    shadowColor: Colors.shadow.medium,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 4,
    elevation: 4,
  },
  
  large: {
    shadowColor: Colors.shadow.dark,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 8,
    elevation: 8,
  },
  
  floating: {
    shadowColor: Colors.shadow.dark,
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 1,
    shadowRadius: 16,
    elevation: 12,
  },
};

export const Layout = {
  // 屏幕边距
  screenPadding: Spacing.base,
  
  // 组件间距
  componentSpacing: Spacing.lg,
  
  // 最小触摸目标
  minTouchTarget: 44,
  
  // 输入框高度
  inputHeight: 48,
  
  // 按钮高度
  buttonHeight: {
    small: 36,
    medium: 44,
    large: 52,
  },
  
  // 头像尺寸
  avatarSize: {
    small: 32,
    medium: 40,
    large: 56,
    xl: 80,
  },
  
  // 间距 - 引用Spacing
  spacing: Spacing,
};

// 动画配置
export const Animation = {
  duration: {
    fast: 150,
    normal: 300,
    slow: 500,
  },
  
  easing: {
    linear: 'linear' as const,
    ease: 'ease' as const,
    easeIn: 'ease-in' as const,
    easeOut: 'ease-out' as const,
    easeInOut: 'ease-in-out' as const,
  },
};

// 断点 (响应式设计)
export const Breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
};

export default {
  Colors,
  Typography,
  Spacing,
  BorderRadius,
  Shadows,
  Layout,
  Animation,
  Breakpoints,
};
